/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TaxRateV2Dto as DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto } from '../../models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/tax-rate-v-2-dto';
import { UpdateTaxRateV2Dto as DigiworkMaitreDPosDtoTaxRatesV2UpdateTaxRateV2Dto } from '../../models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/update-tax-rate-v-2-dto';

export interface UpdateTaxRate_1$Params {
  taxRateId: string;
      body?: DigiworkMaitreDPosDtoTaxRatesV2UpdateTaxRateV2Dto
}

export function updateTaxRate_1(http: HttpClient, rootUrl: string, params: UpdateTaxRate_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto>> {
  const rb = new RequestBuilder(rootUrl, updateTaxRate_1.PATH, 'put');
  if (params) {
    rb.path('taxRateId', params.taxRateId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto>;
    })
  );
}

updateTaxRate_1.PATH = '/api/tax-rates/{taxRateId}';
